import { useState, useRef } from 'react';
import { HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { useSelector } from 'react-redux';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import useConfig from '../../../Hooks/useConfig';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function ImportUsers() {
    const { usersFileType, csvFilesPrefix } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const StudentRef = useRef();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [fileName, setFileName] = useState({
        users: '',
        fileError: ''
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const navigate = useNavigate();
    const [csvError, setCsvError] = useState("");

    async function ImportUsersCSV(e) {
        setCsvError('');
        setLoading(true)
        e.preventDefault();
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });

        const fileInput = StudentRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false);
            setFileName({ ...fileName, fileError: "First, import the CSV file.", users: "" });
            return;
        }
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setLoading(false);
            setFileName({ ...fileName, fileError: validationMsg, users: "" });
            return;
        }
        setFileName({ ...fileName, users: filename, fileError: "" });

        var formdata = new FormData();
        formdata.append("file", files);
        formdata.append("uuid", StateData?.csvUserID);
        formdata.append("schoolId", LogInSchoolID);

        try {
            const response = await ApiCmnHeadersPostCall(`/utilizers/import`, formdata);
            setLoading(false);
            const responseRs = JSON.parse(response);
            if (responseRs.response == "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={'If there was any mismatched or invalid data, or any mismatched headers in your CSV, those entries would have been skipped.'} />);
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    navigate('/users')
                }, 4000);
            } else {
                setCsvError(responseRs);
                setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                setFileName({ ...fileName, fileError: '', users: "" })
                fileInput.value = "";
            }
            setFileName({ ...fileName, fileError: '', users: "" })
            fileInput.value = "";
        } catch (error) {
            log.error('error', error);
            setFileName({ ...fileName, fileError: '', users: "" })
            fileInput.value = "";
        }

    }
    function ShowFileName(flag) {
        const fileInput = StudentRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, fileError: validationMsg, users: "" })
            return;
        }
        setFileName({ ...fileName, fileError: "", users: filename });
    }
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Users</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure that Users are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your users into the system.
                </p>
                <div className="row pt-3 px-3">
                    <label className="pb-4 ps-0 text-justify" style={{ fontSize: "13px" }}>
                        <a onClick={() => downloadSampleCSV(usersFileType, `${csvFilesPrefix ? `${csvFilesPrefix}_` : ''}Users.csv`)}
                            style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                            CLICK HERE
                        </a> {" "}
                        to download the template CSV file for users data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                    </label>
                    <div className="col-12">
                        <div className="d-flex gap-3 align-items-center">
                            <form onSubmit={(e) => ImportUsersCSV(e)}>
                                <input type="file" ref={StudentRef} name="student_file" id="StudentUploadFile" accept='.csv' onChange={(e) => ShowFileName(3)} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="StudentUploadFile"> Import Users
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.users != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        <div id="ImportInventoryStudentText" style={{ fontWeight: "600", color: 'green' }}>{fileName.users}</div>
                        {fileName.fileError?.trim() != "" && <label className='redText'>{fileName.fileError}</label>}
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
